import { gql } from '__generated__';

export default gql(`
  query GetDiscounts($project_id: ID!, $event_id: ID!, $search: String) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        active
        discounts(search: $search) {
          id
          title
          type
          levels {
            id
            value
          }
          uses
          start_date
          end_date
          active
          deletable
        }
      }
    }
  }
`);
